import PropTypes from 'prop-types';
import { useMemo } from 'react';

import PaxityProgress from './PaxityProgress';
import { useTitle } from './React';

const LoadingPage = function LoadingPage(props) {
  const {
    title = 'chargement...',
    error,
    timedOut = false,
    pastDelay = true,
    pendingTxt = '...',
  } = props;

  useTitle(title);

  const content = useMemo(
    () => {
      if (error) return <span>Erreur de chargement, essayez à nouveau ultérieurement...</span>;

      if (timedOut) return <span>Le chargement semble avoir échoué, essayez de rafraichir?</span>;

      if (pastDelay) {
        return (
          <>
            <PaxityProgress />
            {pendingTxt}
          </>
        );
      }

      return null;
    },
    [error, timedOut, pastDelay, pendingTxt],
  );

  return (
    <div className="relative w-screen h-screen max-h-screen bg-white flex flex-col justify-center items-center text-pxGrey overflow-hidden px-4 py-2">
      <div className="relative w-full flex flex-col m-auto items-center relative overflow-y-auto gap-4 font-bold">
        {content}
      </div>
    </div>
  );
};

LoadingPage.propTypes = {
  // From react-loadable
  error: PropTypes.shape({}),
  timedOut: PropTypes.bool,
  pastDelay: PropTypes.bool,

  title: PropTypes.string,
  pendingTxt: PropTypes.string,
};

export default LoadingPage;
